import { render, staticRenderFns } from "./ProcessedExpenseItem.vue?vue&type=template&id=90150258&scoped=true"
import script from "./ProcessedExpenseItem.vue?vue&type=script&lang=js"
export * from "./ProcessedExpenseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90150258",
  null
  
)

export default component.exports